// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Lang from 'vue-lang'
import languages from './languages'
import moment from 'moment-timezone'
import 'moment/locale/pt-br'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import vSelect from 'vue-select'
import VeeValidate from 'vee-validate'
import VeeValidateConfig from './config/veeValidate'
import ToastrInstaller from './components/UI/toastr/Toastr'
import './shared/mixins'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import money from 'v-money'
import EventHub from 'vue-event-hub'
import {ColorPicker, ColorPanel} from 'one-colorpicker'
import VueFlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import VueTheMask from 'vue-the-mask'
import Vue2TouchEvents from 'vue2-touch-events'
import VueI18n from 'vue-i18n'

import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

import VueFab from 'vue-float-action-button'
import VueFormulate from '@braid/vue-formulate'
import NxInput from '@/components/nexum/components/inputs/NxInput.vue'
import NxSelect from '@/components/nexum/components/selects/NxSelect.vue'
import NxSelectReduced from '@/components/nexum/components/selects/NxSelectReduced.vue'
import NxRadioButton from '@/components/nexum/components/buttons/NxRadioButton.vue'

import nxLite from './languages/nxLite.json'
import nxCoop from './languages/default.json'

import CustomError from '@/errors/customError.js'

if (process.env.NODE_ENV === 'production') {
  require('../scss/style.scss')
}

Vue.use(mavonEditor)
Vue.use(EventHub)
Vue.use(VueTheMask)
Vue.use(Lang, { lang: 'ptBr', locales: languages })
moment.locale('pt-br')
Vue.prototype.moment = moment
Vue.use(BootstrapVue)
Vue.use(VeeValidate, VeeValidateConfig)
Vue.component('v-select', vSelect)
ToastrInstaller.Install()
Vue.component('autocomplete', VueBootstrapTypeahead)
Vue.use(money, {precision: 4})
Vue.use(ColorPanel)
Vue.use(ColorPicker)
Vue.use(VueFlatPickr)
Vue.use(Vue2TouchEvents)
Vue.use(VueI18n)

const defaultLanguage = process.env.hasLite ? 'nxLite' : 'nxCoop'

const i18n = new VueI18n({
  locale: defaultLanguage,
  messages: {
    nxCoop,
    nxLite
  }
})

Vue.component('v-fab', VueFab)
Vue.use(VueFab)
Vue.use(VueFormulate)
Vue.component('NxInput', NxInput)
Vue.component('NxSelect', NxSelect)
Vue.component('NxSelectReduced', NxSelectReduced)
Vue.component('NxRadioButton', NxRadioButton)

window.CustomError = CustomError

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js